export const defaultMisaOrderState = {
	lstBank: []
};

export default {
	...defaultMisaOrderState
};
